import { useState, useEffect } from 'react'
import { useQueryClient } from "react-query"
import { usePaystackPayment } from 'react-paystack';
import { useStore } from "../contexts/Store.context"
import { useModal } from "../contexts/Modal.context"

export default function PaystackPayment() {
    const { notify } = useModal()
    const queryClient = useQueryClient()
    const { currentUser, payWithPlanCode, setPayWithPlanCode } = useStore()
    const [planCode, setPlanCode] = useState(null) // For transaction linked to a plan

    const config = {
        amount: 1500000,
        currency: "NGN",
        email: currentUser?.email,
        plan: planCode ?? planCode ?? "",
        reference: (new Date()).getTime(),
        publicKey: process.env.REACT_APP_PAYSTACK_KEY,
    }

    const initializePayment = usePaystackPayment(config);

    useEffect(() => {
        if (planCode) {
            console.log(config)
            initializePayment(onSuccess, onClose)
        }
    }, [planCode]);

    useEffect(() => {
        if (payWithPlanCode) setPlanCode(payWithPlanCode)
    }, [payWithPlanCode]);

    function onSuccess() {
        // Implementation for whatever you want to do with reference and after success call.
        queryClient.refetchQueries("subscriptions")
        queryClient.refetchQueries("customer-data")
        notify("Subscription created successfully")
        setPlanCode(null)
        setPayWithPlanCode(null)
    };

    function onClose() {
        setPlanCode(null)
        setPayWithPlanCode(null)
    }

    return null
}